module.exports = __webpack_public_path__ + "img/task.ce8d91a5.svg";